import { ElMessageBox, ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
import apis from '@/api';
import { watch, reactive, toRefs } from 'vue';
import dayjs from 'dayjs';
export default {
  props: {
    id: String
  },
  setup(props) {
    const data = reactive({
      assetId: '',
      bizs: [],
      defaultStartTime: new Date(2000, 1, 1, 0, 0, 0),
      defaultEndTime: new Date(2000, 2, 1, 23, 59, 59)
    });
    const loadData = () => {
      apis.assetsBizs(data.assetId).then(res => {
        if (res.success) {
          //console.log(res.data, "aessetsBizs")
          data.bizs = res.data;
        }
      });
    };
    watch(() => props.id, id => {
      data.assetId = id;
      loadData();
    }, {
      immediate: true
    });
    const editProduct = idx => {
      data.bizs[idx].editable = true;
      //console.log(data.bizs)
    };
    const saveProduct = idx => {
      data.bizs[idx].editable = false;
      data.bizs[idx].startTime = typeof data.bizs[idx].startTime == "object" ? dayjs(data.bizs[idx].startTime).format("YYYY-MM-DD HH:mm:ss") : data.bizs[idx].startTime;
      data.bizs[idx].endTime = typeof data.bizs[idx].endTime == "object" ? dayjs(data.bizs[idx].endTime).format("YYYY-MM-DD HH:mm:ss") : data.bizs[idx].endTime;
      //console.log(data.bizs[idx], "save")

      ElMessageBox.confirm('确定要修改该关联业务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apis.editAssetsBiz(data.bizs[idx]).then(res => {
          if (res.success) {
            ElMessage.success("保存成功");
            loadData();
          } else {
            ElMessage.error(res.msg);
          }
        });
      }).catch(() => {
        loadData();
      });
    };
    const deleteProduct = idx => {
      //console.log(data.bizs[idx].id, "delete data.bizs[idx].id")
      ElMessageBox.confirm('确定要删除该关联业务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apis.deleteAssetsBiz(data.bizs[idx].id).then(res => {
          if (res.success) {
            ElMessage.success("删除成功");
            loadData();
          } else {
            ElMessage.error(res.msg);
          }
        });
      }).catch(() => {
        loadData();
      });
    };
    return {
      ...toRefs(data),
      loadData,
      editProduct,
      saveProduct,
      deleteProduct
    };
  }
};